module.exports = __webpack_public_path__ + "img/big_1_21.b784e938.png";